var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83334 5C2.83334 4.72386 3.05719 4.5 3.33334 4.5H16.6667C16.9428 4.5 17.1667 4.72386 17.1667 5C17.1667 5.27614 16.9428 5.5 16.6667 5.5H3.33334C3.05719 5.5 2.83334 5.27614 2.83334 5ZM2.83334 10C2.83334 9.72386 3.05719 9.5 3.33334 9.5H16.6667C16.9428 9.5 17.1667 9.72386 17.1667 10C17.1667 10.2761 16.9428 10.5 16.6667 10.5H3.33334C3.05719 10.5 2.83334 10.2761 2.83334 10ZM2.83334 15C2.83334 14.7239 3.05719 14.5 3.33334 14.5H16.6667C16.9428 14.5 17.1667 14.7239 17.1667 15C17.1667 15.2761 16.9428 15.5 16.6667 15.5H3.33334C3.05719 15.5 2.83334 15.2761 2.83334 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHamburger);
export default __webpack_public_path__ + "static/media/menu-hamburger.361ee45d77a5bdfaa4521cef7d351450.svg";
export { ForwardRef as ReactComponent };